import { useTranslation } from 'react-i18next'
import { GripVertical } from 'lucide-react'
import type { DragHandleProps } from './SortableGrid'

/**
 * Drag handle for a sortable card. Spread the `handle` from `SortableGrid`'s
 * `renderItem` onto it. `touch-none` keeps touch drags from scrolling the page;
 * the click is swallowed so tapping the handle never triggers the card's own
 * click (open). Reads its own aria-label from `common`.
 */
export function DragHandle({ attributes, listeners }: DragHandleProps) {
  const { t } = useTranslation('common')
  return (
    <button
      type="button"
      aria-label={t('dnd.reorderHandle')}
      className="flex size-7 shrink-0 cursor-grab touch-none items-center justify-center rounded text-muted-foreground hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring active:cursor-grabbing"
      onClick={(e) => e.stopPropagation()}
      {...attributes}
      {...listeners}
    >
      <GripVertical className="size-4" />
    </button>
  )
}
